export default __webpack_public_path__ + "static/media/facebook.c799c639.svg";